import React, { useCallback } from 'react';
import { isBannersPage } from '@productSearch/utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import * as Styled from './FiltersListContainer.styles';
import { BrandSwitch } from '../../components/Filter/BrandSwitch';
import { FamilyViewSwitch } from '../../components/Filter/FamilyViewSwitch';
import { FilterSwitch } from '../../components/Filter/FilterSwitch';
import { appFiltersSelector } from '../../redux/selectors/filtersSelector';
import {
  addFilter,
  removeFilter,
} from '../../redux/sliceCreators/filtersSlice';

import { FilterData, FilterDataValues } from '../../types';

const isCollectionsPage = isBannersPage();

type SwitchRendererProps = {
  switches: FilterDataValues[];
};

export function SwitchRenderer({ switches }: SwitchRendererProps) {
  const dispatch = useDispatch();
  const appFilters = useSelector(appFiltersSelector);

  const handleToggleSwitch = useCallback(
    (value: FilterData, isActive: boolean) => {
      if (!isActive) {
        dispatch(addFilter(value));
      } else {
        dispatch(removeFilter(value));
      }
    },
    [dispatch],
  );

  return (
    <Styled.SwitchesWrapper>
      {switches.map((filter) => (
        <FilterSwitch
          key={`${filter?.field}-${filter?.label}`}
          data={filter}
          appFilters={appFilters}
          onToggleSwitch={handleToggleSwitch}
        />
      ))}
      {!isCollectionsPage && <FamilyViewSwitch />}
      <BrandSwitch />
    </Styled.SwitchesWrapper>
  );
}
